export default __webpack_public_path__ + "static/media/medpass.2c3540e0.png";